import qs from 'query-string';
import { apiConfig } from '../api-config';

export interface UpdateSetReadAppointmentParams {
  tokenKey: string;
  serialId: number;
  cdUser: number;
  cdAgent: string;
}

export const updateSetReadAppointment = async (params: UpdateSetReadAppointmentParams) => {
  const query = qs.stringify(params);
  return apiConfig
    .patch(`/api/Appointments/update-appointment-set-read?${query}`)
    .catch((err) => ({ hasErrors: true, err }));
};
